
<template>
    <component :is="'div'">

        <b-alert
            variant="danger"
            :show="newsData === undefined"
        >
            <h4 class="alert-heading">Error al obtener los datos de la noticia</h4>
            <div class="alert-body">
                No se encontró ninguna noticia con este id. Verificar en la
                <b-link class="alert-link" :to="{ name: 'news' }">Lista de noticias</b-link>
                para buscar otra noticia
            </div>
        </b-alert>

        <news-edit-tab-information
            v-if="newsData"
            :news-data="newsData"
        />
    </component>
</template>

<script>

    import NewsEditTabInformation from './NewsEditTabInformation.vue';
    import { onUnmounted, ref } from '@vue/composition-api';
    import newsStoreModule from '../newsStoreModule';
    import router from '@/router';
    import store from '@/store';

    export default {
        components: {
            NewsEditTabInformation
        },
        setup() {
            const newsData = ref(null);

            const NEWS_APP_STORE_MODULE_NAME = 'app-news';

            if (!store.hasModule(NEWS_APP_STORE_MODULE_NAME)) store.registerModule(NEWS_APP_STORE_MODULE_NAME, newsStoreModule);

            onUnmounted(() => {
                if (store.hasModule(NEWS_APP_STORE_MODULE_NAME)) store.unregisterModule(NEWS_APP_STORE_MODULE_NAME)
            });

            store.dispatch('app-news/fetchNews', { id: router.currentRoute.params.id })
                .then(response => {
                    if (response.data === 'error') {
                        newsData.value = undefined
                    } else {
                        newsData.value = response.data;
                    }
                })
                .catch(error => {
                    if (error.response.status === 404) {
                        newsData.value = undefined
                    }
                });

            return {
                newsData
            }
        }
    }

</script>
